import { app } from "modular-openscriptjs";

const h = app("h");

export default function FeaturedBusinessView(business, ...args) {
    let companyName = business?.name || business?.display_name || "Business";
    let handle = business?.handle || business?.username || "";
    let logoPath = business?.logo_path || business?.logo || business?.profile_photo_path;
    let coverPath = business?.cover_path || business?.cover_image;
    let openStatus = business?.branches_open_status;
    let isVerified = business?.is_approved || business?.is_verified;
    let initial = companyName.charAt(0).toUpperCase();

    return h.div(
        {
            class: "featured-business-card position-relative bg-white rounded-4 shadow-sm overflow-hidden border border-light",
            role: "button",
            style: "width: 280px; flex-shrink: 0;",
            onclick: h.func("app('router').to", "business.view-profile", {
                businessId: business?.id,
            }),
        },
        // Open Status Badge on Top-Left
        h.div(
            { class: "position-absolute top-0 start-0 p-2", style: "z-index: 10;" },
            h.span(
                {
                    class: "badge shadow-sm px-2 py-1 rounded-pill fw-bold d-inline-flex align-items-center gap-1",
                    style: "font-size: 0.7rem; background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(4px);",
                },
                h.call(() => {
                    if (openStatus === "all") {
                        return [
                            h.i({ class: "bi bi-circle-fill text-success", style: "font-size: 0.45rem;" }),
                            h.span({ class: "text-success" }, "Open Now"),
                        ];
                    }
                    if (openStatus === "some") {
                        return [
                            h.i({ class: "bi bi-circle-half text-primary", style: "font-size: 0.45rem;" }),
                            h.span({ class: "text-primary" }, "Open Outlets"),
                        ];
                    }
                    return [
                        h.i({ class: "bi bi-circle text-dark", style: "font-size: 0.45rem;" }),
                        h.span({ class: "text-dark" }, "Closed"),
                    ];
                })
            )
        ),
        // Cover Image Section
        coverPath
            ? h.div({
                  class: "w-100 position-relative",
                  style: "padding-top: 45%; background: url('" + coverPath + "') no-repeat center center; background-size: cover;",
              })
            : h.div(
                  {
                      class: "w-100 position-relative overflow-hidden",
                      style: "padding-top: 45%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);",
                  },
                  h.div(
                      {
                          class: "position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center",
                      },
                      h.span(
                          {
                              class: "text-white fw-bold opacity-25 user-select-none",
                              style: "font-size: 4rem; transform: rotate(-15deg); line-height: 1;",
                          },
                          initial
                      )
                  )
              ),
        // Bottom Content Section with Overlapping Logo, Name & Handle
        h.div(
            {
                class: "px-3 pb-3 pt-0 position-relative",
            },
            h.div(
                { class: "d-flex align-items-end gap-2 mb-2", style: "margin-top: -24px;" },
                // Logo
                h.div(
                    { class: "flex-shrink-0 position-relative", style: "z-index: 2;" },
                    logoPath
                        ? h.img({
                              src: logoPath,
                              class: "rounded-3 shadow-sm bg-white",
                              style: "width: 52px; height: 52px; object-fit: cover;",
                              alt: companyName,
                          })
                        : h.div(
                              {
                                  class: "rounded-3 border border-2 border-white shadow-sm d-flex align-items-center justify-content-center fw-bold text-white fs-5",
                                  style: "width: 52px; height: 52px; background: linear-gradient(135deg, #0d6efd 0%, #0098f0 100%);",
                              },
                              initial
                          )
                ),
                // Name and Handle Stack with blurred white background (matching BusinessProfileDefault)
                h.div(
                    {
                        class: "flex-grow-1 overflow-hidden p-2 rounded-3 shadow-sm text-start",
                        style: "background: rgba(255, 255, 255, 0.85); backdrop-filter: blur(8px); z-index: 2;",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-1" },
                        h.span(
                            {
                                class: "fw-bold text-dark text-truncate d-block",
                                style: "font-size: 0.9rem; line-height: 1.2;",
                                title: companyName,
                            },
                            companyName
                        ),
                        isVerified
                            ? h.i({
                                  class: "bi bi-patch-check-fill text-primary flex-shrink-0",
                                  style: "font-size: 0.85rem;",
                                  title: "Verified Business",
                              })
                            : null
                    ),
                    handle
                        ? h.span(
                              { class: "text-muted small text-truncate d-block", style: "font-size: 0.75rem; line-height: 1.1;" },
                              "@",
                              handle
                          )
                        : null
                )
            )
        ),
        ...args
    );
}
